function toDocumentTypeFormatter(value: any) {
  if (value !== null && value !== undefined) {
    // Underground = 1,
    // Overhead = 2,
    // Drafting = 3,
    // Detailing = 4,
    // ProjectManagement = 5,
    switch (value) {
      case 0:
        return 'Supplied';
        break;

      case 1:
        return 'Internal';
        break;

      case 2:
        return 'Sent';
        break;

      default:
        return '???';
        break;
    }
    
  } else {
    return '???';
  }
}

export default toDocumentTypeFormatter;
